import { BaseService } from './core/BaseService';
import { Model } from '../types';

class ModelApiService extends BaseService {
  async getModels(): Promise<Model[]> {
    const data = await this.get('/api/models');
    return Array.isArray(data) ? data : (data as any).models || [];
  }

  async getLlmModels(): Promise<Model[]> {
    const data = await this.get('/api/models?category=llm');
    return Array.isArray(data) ? data : (data as any).models || [];
  }
}

export const modelApi = new ModelApiService();
